import defaults from './defaults';

export const initialize = (options) => ({
    ...defaults, 
    ...options, 
    headers: {
        ...defaults.headers, 
        ...options.headers,
    }
})

export const global = (options) => {
    Object.assign(defaults, options)
}

export function ServerResponse (xhr) {
    this.data = xhr.response
    this.status = xhr.status
    this.statusText = xhr.statusText
    this.headers = xhr.getAllResponseHeaders().split(/\n/)
    .reduce((result, header) => {
        const [key, value] = header.split(": ")
        if(key && value)
            result[key] = value
        return result
    }, {})
}